import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { VwTramDoc} from '../../shared/interfaces/database/configuracion';

@Injectable({
  providedIn: 'root'
})
export class TramDocService {
  private readonly baseUrl = `${environment.apiUrl}/api/tram-doc`;

  constructor(private http: HttpClient) { }

  getTramDocsByTipotramiteId(tipoTramiteId: number): Observable<VwTramDoc[]> {
    return this.http.get<VwTramDoc[]>(`${this.baseUrl}/${tipoTramiteId}`);
  }
}
